import fileType from "file-type";

export default {
  methods: {
    pageCount: function (value) {
      if (!value) return 0;
      const bin = atob(value);
      return bin.match(/\/Type\s*\/Page\b/g).length;
    },

    downloadFile: async function (attachment, filename = "") {
      const myBuffer = Buffer.from(attachment, "base64");
      const res = await fileType.fromBuffer(myBuffer);

      const blob = new Blob([myBuffer], { type: res.mime });
      const url = URL.createObjectURL(blob);

      const ext = res.mime.split("/").pop();
      const filePath = `${filename || "attachment"}.${ext}`;

      const element = document.createElement("a");
      element.href = url;
      element.download = filePath;
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);

      URL.revokeObjectURL(url);
    },
  },
};
